import { B2bSavingPlanDeductibility } from '@Common/types/b2b/plans';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const voluntaryPaymentTypeChoices = makeChoicesCommon<'voluntary_payment' | 'arbitrage'>()({
  voluntary_payment:
    'resources.bo_common.b2b.voluntary_payment_create.choices.type.voluntary_payment',
  arbitrage: 'resources.bo_common.b2b.voluntary_payment_create.choices.type.arbitrage',
});

export const voluntaryPaymentDeductibilityChoices = makeChoicesCommon<B2bSavingPlanDeductibility>()(
  {
    deductible: 'resources.bo_common.b2b.voluntary_payment_create.choices.deductibility.deductible',
    non_deductible:
      'resources.bo_common.b2b.voluntary_payment_create.choices.deductibility.non_deductible',
  },
);
